import type { ComponentSchema } from "../../../../../schema-types"
import { SLIDE_SCHEMA } from '../../_builder-constants'
import { primaryButtonFields } from "../shared/button-schema-fields"

export const schema: ComponentSchema = {
  type: 'hero',
  label: 'Hero Section',
  description: 'The main attention-grabbing section at the top of the page.',
  supportedPages: ['home', 'cart', 'checkout', 'order-success', 'categories'],
  variants: [
    {
      id: 'v4',
      label: 'V4 (Premium Full Width Slider)',
      fields: [
        { key: 'slides', label: 'Slides', type: 'array', itemSchema: SLIDE_SCHEMA },
        { key: 'autoplay', label: 'Auto Play', type: 'boolean', default: true },
        { key: 'autoplayDelay', label: 'Auto Play Interval (ms)', type: 'number', default: 5000 },
      ],
    },
  ],
  commonFields: [
    // ─── CTA Button ───────────────────────────────────────────────────
    ...primaryButtonFields('buttons.cta', 'CTA Button'),
  ],
}
